/** Large curated list of undergraduate majors / fields of study (searchable; free text still allowed). */
export const RAW_UNDERGRADUATE_MAJORS: string[] = [
  "Accounting",
  "Actuarial Science",
  "Advertising",
  "Aeronautical Engineering",
  "Aerospace Engineering",
  "African American Studies",
  "African Studies",
  "Agribusiness",
  "Agricultural and Biological Engineering",
  "Agricultural Business",
  "Agricultural Economics",
  "Agricultural Education",
  "Agricultural Engineering",
  "Agricultural Science",
  "Agriculture",
  "American Studies",
  "Animal Behavior",
  "Animal Science",
  "Anthropology",
  "Applied Economics",
  "Applied Linguistics",
  "Applied Mathematics",
  "Applied Physics",
  "Archaeology",
  "Architectural Engineering",
  "Architecture",
  "Art Education",
  "Art History",
  "Asian American Studies",
  "Asian Studies",
  "Astronomy",
  "Astronomy and Astrophysics",
  "Atmospheric Science",
  "Behavioral Economics",
  "Behavioral Neuroscience",
  "Biochemistry",
  "Biochemistry and Molecular Biology",
  "Bioengineering",
  "Bioinformatics",
  "Biological Chemistry",
  "Biological Engineering",
  "Biological Sciences",
  "Biology",
  "Biomedical Computation",
  "Biomedical Engineering",
  "Biomedical Sciences",
  "Biomolecular Engineering",
  "Biophysics",
  "Biostatistics",
  "Biotechnology",
  "Black Studies",
  "Business Administration",
  "Business Analytics",
  "Business and Technology",
  "Business Economics",
  "Cell and Developmental Biology",
  "Cell Biology",
  "Chemical and Biomolecular Engineering",
  "Chemical Biology",
  "Chemical Engineering",
  "Chemical Physics",
  "Chemical Sciences",
  "Chemistry",
  "Chicana and Chicano Studies",
  "Child Development",
  "Chinese",
  "Cinematic Arts",
  "Civic Technology",
  "Civil and Environmental Engineering",
  "Civil Engineering",
  "Classics",
  "Climate Science",
  "Cognitive and Brain Sciences",
  "Cognitive Science",
  "Communication",
  "Communication Design",
  "Communication Studies",
  "Communicative Disorders",
  "Community Health",
  "Comparative Literature",
  "Computational Biology",
  "Computational Finance",
  "Computational Media",
  "Computational Neuroscience",
  "Computational Science and Engineering",
  "Computer Engineering",
  "Computer Game Design",
  "Computer Science",
  "Computer Science and Business Administration",
  "Computer Science and Engineering",
  "Computer Science and Mathematics",
  "Conservation Biology",
  "Construction Management",
  "Consumer Economics",
  "Contemporary Dance",
  "Corporate Finance",
  "Creative Technologies",
  "Creative Writing",
  "Criminal Justice",
  "Criminology",
  "Cultural Anthropology",
  "Cultural Studies",
  "Cyber-Physical Systems",
  "Cybersecurity",
  "Dance",
  "Dance and Choreography",
  "Data Analytics",
  "Data Engineering",
  "Data Science",
  "Design",
  "Digital Arts",
  "Digital Culture",
  "Digital Media",
  "Earth and Environmental Sciences",
  "Earth and Planetary Sciences",
  "Earth Science",
  "Earth Systems Science",
  "East Asian Studies",
  "Ecology and Evolutionary Biology",
  "Economics",
  "Economics and Computer Science",
  "Ecosystem Science",
  "Education",
  "Educational Studies",
  "Electrical and Computer Engineering",
  "Electrical and Systems Engineering",
  "Electrical Engineering",
  "Electrical Engineering and Computer Science",
  "Electrical Engineering and Physics",
  "Energy and Resources",
  "Energy Engineering",
  "Energy Systems",
  "Engineering Management",
  "Engineering Physics",
  "Engineering Science",
  "English",
  "English and Creative Writing",
  "Entrepreneurship",
  "Entrepreneurship and Innovation",
  "Environmental and Sustainability Sciences",
  "Environmental Chemistry",
  "Environmental Design",
  "Environmental Economics",
  "Environmental Engineering",
  "Environmental Geology",
  "Environmental Health",
  "Environmental Policy",
  "Environmental Science",
  "Environmental Studies",
  "Ethnic Studies",
  "Ethnomusicology",
  "European Studies",
  "Evolutionary Anthropology",
  "Exercise Science",
  "Fashion Design",
  "Fiber Science",
  "Film and Media Studies",
  "Film Production",
  "Film Studies",
  "Finance",
  "Financial Economics",
  "Financial Engineering",
  "Financial Mathematics",
  "Food Business Management",
  "Food Science",
  "Forensic Science",
  "Forestry",
  "French",
  "Game Design",
  "Gender Studies",
  "Genetics",
  "Genomics",
  "Geographic Information Science",
  "Geography",
  "Geological Sciences",
  "Geology",
  "Geophysics",
  "German",
  "Global Business",
  "Global Development Studies",
  "Global Health",
  "Global Studies",
  "Graphic Design",
  "Health and Human Sciences",
  "Health Informatics",
  "Health Policy",
  "Health Promotion",
  "History",
  "History of Art",
  "Hospitality Management",
  "Human Biology",
  "Human Computer Interaction",
  "Human Development",
  "Human Resource Management",
  "Human-Centered Design",
  "Humanities",
  "Humanities and Sciences",
  "Immigration Studies",
  "Immunology",
  "Industrial and Labor Relations",
  "Industrial and Operations Engineering",
  "Industrial Design",
  "Industrial Distribution",
  "Industrial Engineering",
  "Informatics",
  "Information Assurance",
  "Information Science",
  "Information Systems",
  "Information Technology",
  "Innovation and Design",
  "Integrated Business and Engineering",
  "Integrated Design",
  "Integrated Science",
  "Intelligence Studies",
  "Interdisciplinary Studies",
  "International Affairs",
  "International Business",
  "International Relations",
  "International Studies",
  "Italian",
  "Japanese",
  "Jewish Studies",
  "Journalism",
  "Kinesiology",
  "Landscape Architecture",
  "Latin",
  "Latin American Studies",
  "Latina/Latino Studies",
  "Law and Society",
  "Learning Sciences",
  "Legal Studies",
  "Liberal Arts",
  "Life Sciences",
  "Linguistics",
  "Linguistics and Computer Science",
  "Logistics and Supply Chain Management",
  "Management",
  "Management Information Systems",
  "Manufacturing Engineering",
  "Marine Biology",
  "Marine Engineering",
  "Marine Science",
  "Marketing",
  "Materials Chemistry",
  "Materials Engineering",
  "Materials Science",
  "Materials Science and Engineering",
  "Mathematical Biology",
  "Mathematical Sciences",
  "Mathematics",
  "Mathematics and Computer Science",
  "Mathematics and Economics",
  "Mechanical and Aerospace Engineering",
  "Mechanical Engineering",
  "Mechatronics Engineering",
  "Media Arts and Sciences",
  "Media Production",
  "Media Studies",
  "Medical Anthropology",
  "Medical Humanities",
  "Meteorology",
  "Microbial Biology",
  "Microbiology",
  "Middle Eastern Studies",
  "Middle Grades Education",
  "Molecular and Cell Biology",
  "Molecular Biology",
  "Molecular Biophysics",
  "Molecular Engineering",
  "Museum Studies",
  "Music",
  "Music Composition",
  "Music Education",
  "Music Industry",
  "Music Performance",
  "Nanotechnology",
  "Native American Studies",
  "Natural Resources",
  "Neural Engineering",
  "Neurobiology",
  "Neuroscience",
  "Nuclear Engineering",
  "Nursing",
  "Nutrition and Dietetics",
  "Nutrition Science",
  "Ocean Engineering",
  "Oceanography",
  "Operations Research",
  "Operations Research and Engineering",
  "Operations Research and Financial Engineering",
  "Organizational Leadership",
  "Organizational Studies",
  "Peace and Conflict Studies",
  "Petroleum Engineering",
  "Pharmaceutical Sciences",
  "Pharmacology",
  "Philosophy",
  "Philosophy of Science",
  "Philosophy, Politics and Economics",
  "Photography",
  "Physical Education",
  "Physical Sciences",
  "Physics",
  "Physiology",
  "Planetary Science",
  "Plant Sciences",
  "Political Economy",
  "Political Science",
  "Polymer Science and Engineering",
  "Population Health",
  "Portuguese",
  "Pre-Dentistry",
  "Pre-Law",
  "Pre-Medicine",
  "Pre-Veterinary Medicine",
  "Product Design",
  "Professional Communication",
  "Professional Writing",
  "Psychology",
  "Public Administration",
  "Public Affairs",
  "Public Health",
  "Public Interest Technology",
  "Public Policy",
  "Public Relations",
  "Quantitative Biology",
  "Quantitative Economics",
  "Quantitative Finance",
  "Quantitative Social Science",
  "Race and Ethnic Studies",
  "Radiological Sciences",
  "Real Estate",
  "Real Estate Development",
  "Recreation Management",
  "Religious Studies",
  "Retail Merchandising",
  "Robotics",
  "Russian",
  "Science and Technology Policy",
  "Science Education",
  "Science, Technology and Society",
  "Secondary Education",
  "Slavic Studies",
  "Social Data Science",
  "Social Entrepreneurship",
  "Social Justice Studies",
  "Social Policy",
  "Social Work",
  "Sociology",
  "Software Engineering",
  "South Asian Studies",
  "Southeast Asian Studies",
  "Space Sciences",
  "Spanish",
  "Speech Communication",
  "Speech, Language and Hearing Sciences",
  "Sport Management",
  "Statistical Science",
  "Statistics",
  "Statistics and Data Science",
  "Strategic Communication",
  "Structural Engineering",
  "Studio Art",
  "Supply Chain Management",
  "Sustainability",
  "Sustainable Design",
  "Sustainable Energy",
  "Systems and Control Engineering",
  "Systems Engineering",
  "Systems Science",
  "Technical Communication",
  "Technical Theater",
  "Technology Management",
  "Textile Engineering",
  "Theater",
  "Theater Arts",
  "Theatre and Drama",
  "Theology",
  "Theoretical Mathematics",
  "Transportation Engineering",
  "Transportation Planning",
  "Turfgrass Science",
  "Undeclared",
  "Urban and Regional Planning",
  "Urban Planning",
  "Urban Studies",
  "User Experience Design",
  "Veterinary Biosciences",
  "Visual Arts",
  "Viticulture and Enology",
  "Water Resources Engineering",
  "Web Design and Development",
  "Welding Engineering",
  "Wildlife Ecology",
  "Women and Gender Studies",
  "World Arts and Cultures",
  "Writing",
  "Zoology",
];
